import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    emoji: '⚡',
    title: 'Total Mental Freedom',
    desc: "Simply open the roadmap, follow the session, and coach. Your entire season's planning is already handled for you."
  }, {
    emoji: '👑',
    title: 'Authority and Presence',
    desc: 'With validated tactical roadmaps, you enter the gym with the posture of an expert. You always have the right answer for your players.'
  }, {
    emoji: '🏆',
    title: 'Consistent Player Development',
    desc: 'Follow a curriculum that respects the principles of skill progression for visible and lasting results.'
  }, {
    emoji: '😌',
    title: 'Zero Competition Stress',
    desc: 'Master special situations and tactical adjustments that will impress players, fans, and peers alike.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <div className="bg-bb-orange/10 text-bb-orange-dark font-bold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-17">
            The Transformation
          </div>
          <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl md:text-5xl text-bb-charcoal leading-tight mb-4 tracking-tight" data-id="element-18">
            The transformation of your{' '}
            <span className="text-bb-orange" data-id="element-19">coaching career</span>
          </h2>
          <p className="text-bb-slate text-lg max-w-2xl mx-auto" data-id="element-20">
            Experience these results from Day 1:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-21">
          {benefits.map((b, idx) => <div key={idx} className="bg-bb-cream rounded-2xl p-7 border border-bb-line hover:border-bb-orange/40 hover:shadow-md hover:-translate-y-1 transition-all" data-id="element-22">
              <div className="text-4xl mb-3" data-id="element-23">{b.emoji}</div>
              <h3 className="font-display font-semibold uppercase text-xl text-bb-charcoal mb-2 leading-tight tracking-wide" data-id="element-24">
                {b.title}
              </h3>
              <p className="text-bb-slate text-base leading-relaxed" data-id="element-25">
                {b.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}